import React from "react";
import { Button } from "react-bootstrap";
import { FieldArrayWithId, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import { SupportAccessFormProps } from "../../../../../../../../services/Api/Organization/organizationTypes";
import { parseSupportAccessDateToLocaleDate } from "../../utils";

interface Props {
	index: number;
	field: FieldArrayWithId<SupportAccessFormProps, "applications", "key">;
	enableAccess: boolean;
	removeLoading: boolean;
	form: UseFormReturn<SupportAccessFormProps>;
}

const SupportAccessFormActions = ({ enableAccess, field, index, removeLoading, form }: Props) => {
	const hasManagePermission = field.user_permissions.includes("MANAGE");
	const { clearErrors, setValue } = form;
	const { t } = useTranslation();

	const updateAppForm = async (actionType: "NO" | "CREATE" | "UPDATE" | "REMOVE") => {
		if (actionType === "UPDATE" || actionType === "CREATE") {
			clearErrors();
			setValue(`applications.${index}.enable_access`, true, { shouldDirty: true });
			setValue(`applications.${index}.support_access_to`, parseSupportAccessDateToLocaleDate(168), {
				shouldDirty: true,
			});
		}
		if (actionType === "REMOVE") {
			clearErrors();
			setValue(`applications.${index}.enable_access`, false, { shouldDirty: true });
		}
	};

	return (
		<div className="d-flex">
			{enableAccess ? (
				<ButtonLoading loading={removeLoading} variant="danger" onClick={() => updateAppForm("REMOVE")}>
					{t(`modules.service_access.action.remove_access.title`)}
				</ButtonLoading>
			) : (
				<Button variant="primary me-1" disabled={!hasManagePermission} onClick={() => updateAppForm("CREATE")}>
					{t(`modules.service_access.action.approve_access.title`)}
				</Button>
			)}
		</div>
	);
};

export default SupportAccessFormActions;
